import Vue from 'vue'
import Vuex from 'vuex'

// track production environment
const debug = process.env.NODE_ENV !== 'production'

// register the Vuex plugin module
Vue.use(Vuex)

// module definitions
import auth from './auth'
import api from './api'
import app from './app'
import config from './config'

// default root state
const state = {
}

// default root getters
const getters = {
}

// default root actions
const actions = {
}

// default root mutations
const mutations = {
}

// create and export the Vuex store
export const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    'auth': auth,
    'api': api,
    'app': app,
    'config': config
  },
  strict: debug
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js